import { Box, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { TooltipContentProps } from 'recharts'
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent'
import Dot from '../../icons/Dot'
import { useTheme } from '../../theme'
import { formatThousands } from '../../utils/formatNumber'

export const CustomTooltip = ({
  active,
  payload,
}: TooltipContentProps<ValueType, NameType>) => {
  const theme = useTheme()
  if (!active) return null
  if (!payload || !payload.length) return null
  return (
    <Box
      sx={{
        width: 180,
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        borderRadius: 1.5,
      }}
    >
      <ListItem
        disablePadding
        secondaryAction={
          <ListItemText
            primaryTypographyProps={{
              variant: 'subtitle2',
              color: theme.palette.common.white,
            }}
            primary={formatThousands(Number(payload[0].value))}
          />
        }
      >
        <ListItemIcon>
          <Dot sx={{ color: payload[0].payload.fill, fontSize: 32 }} />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{
            variant: 'subtitle2',
            color: theme.palette.common.white,
          }}
          primary={payload[0].name}
        />
      </ListItem>
    </Box>
  )
}
